/**
 * Created by Omar Alejandro Leonor Avalos on 2017-07-23.
 * Renders an input with a select
 */
import React, { Component } from 'react';
import { TextField } from 'material-ui';
import { Select } from '../data-containers';

class InputWithOptions extends Component {

    constructor(props) {
        super(props);
        this.state = {
            valueOnSelect: props.options[0].id,
            valueOnTextField: ''
        };
    }

    render() {
        const { valueOnSelect, valueOnTextField } = this.state;
        const { options, inputLabel, selectLabel, inputType, hintText, notify, searchTexts} = this.props;

        return (
            <div>
                <Select
                    value={valueOnSelect}
                    options={options}
                    label={selectLabel}
                    notify={(value) => {
                        this.setState({ valueOnSelect: value });
                        const option = options.find(op => op.id === value);
                        notify(option, searchTexts);
                    }}
                />
                <TextField
                    hintText={hintText}
                    floatingLabelText={inputLabel}
                    floatingLabelFixed
                    fullWidth
                    type={inputType}
                    value={searchTexts}
                    onChange={(event, value) => {
                        this.setState({ valueOnTextField: value });
                        const option = options.find(op => op.id === valueOnSelect);
                        notify(option, value);
                    }}
                />
            </div>
        );
    }
}

export default InputWithOptions;



// WEBPACK FOOTER //
// ./components/filters/InputWithOptions.js